import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  hoverImage: (isOpened: boolean, isSmall: boolean, isSlider: boolean) => {
    const paddingMap = {
      standard: 0,
      small: isSlider ? [32, 32, 32, 64] : 32,
      normal: [32, 32, 64, '4.1666667vw']
    };
    const paddingTypeForSmaller = isSmall ? 'small' : 'normal';
    const paddingType = isOpened ? paddingTypeForSmaller : 'standard';
    return {
      padding: paddingMap[paddingType],
      opacity: 0,
      bg: isOpened ? theme.rawColors.lightGreyBgProduct : 'transparent',
      objectFit: 'cover',
      ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.normal)
    };
  }
};